module.exports = __webpack_public_path__ + "static/media/sitemap.462b243e.svg";